import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./index";

const selectL1ImportFilesState = (state) => state.l1ImportFiles || initialState;

export const selectL1ImportFiles = createSelector(
  [selectL1ImportFilesState],
  (state) => state.l1ImportFiles
);

export const selectUploadedL1File = createSelector(
  [selectL1ImportFilesState],
  (state) => state.l1ImportNewFile
);

export const selectDeleteL1File = createSelector(
  [selectL1ImportFilesState],
  (state) => state.deleteL1File
);

export const l1InsertFileRecordUpload = createSelector(
  [selectL1ImportFilesState],
  (state) => state.l1InsertFileRecord
);


